 export const ActionCard = ({ title, icon, colorClass, onClick }: { title: string, icon: React.ReactNode, colorClass: string, onClick: () => void }) => (
 <div 
  onClick={onClick} 
  className="bg-white p-4 rounded-xl border border-gray-200 flex flex-col items-center justify-center gap-3 cursor-pointer hover:border-blue-500 hover:shadow-md"
 >
  <div className={`w-12 h-12 rounded-2xl ${colorClass} text-white flex items-center justify-center`}>
  {icon}
  </div>
  <span className="text-sm font-semibold text-slate-600 text-center">{title}</span>
 </div>
 );